import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import Btn from 'components/buttons/Btn'
import { useEffect, useState } from 'react'
import { Badge, Card, Col, Collapse, ListGroup, Row } from 'react-bootstrap'
import { klass } from 'utils'
import AllPropTypes from 'utils/prop-types'
import './styles.scss'
import { upperFirst } from "lodash-es"

/**
 * @param header {string|JSX.Element}
 * @param className
 * @param children Should be a list of ListGroup.Item!
 * @param openByDefault
 * @param forceClose {boolean} When set to true, causes the list to close. Setting to false won't cause any effect - this effectively allows the parent element to change back so it can re-request closure.
 * @param split {boolean} Renders as two columns. Needs two <section> children inside each ListGroup.Item
 * @param corner {CollapsibleListGroup.Corner}
 */
export default function CollapsibleListGroup({ header, className, children, split = false, openByDefault = false, forceClose = false, corner = null }) {
	const [isOpen, toggle] = useState(openByDefault)

	useEffect(() => {
		toggle(forceClose? false : isOpen)
	}, [forceClose]) // eslint-disable-line react-hooks/exhaustive-deps

	const OPEN_TXT = ['closed', 'open']

	const cardHeader = !header? null : (
		<Card.Header as="header">
			<Row>
				<Col onClick={() => toggle(!isOpen)}>
					<h2>
						<FontAwesomeIcon icon="angle-down" alt={OPEN_TXT[isOpen]} className={`toggle-arrow ${OPEN_TXT[isOpen]}`}/>
						{typeof header == 'string'? header|>upperFirst : header}{' '}
						<Badge variant="light">{children.length}</Badge>
					</h2>
				</Col>
				{corner && <Col xs="auto" className="corner-wrapper embedded-btn">
					{corner}
				</Col>}
			</Row>
		</Card.Header>
	)

	return (
		<Card as="section" {...klass(className, 'collapsible-list-group', { splitGroup: split })}>
			{cardHeader}
			<Collapse in={isOpen}>
				<ListGroup variant="flush" {...{ children }}/>
			</Collapse>
		</Card>
	)
}

CollapsibleListGroup.propTypes = {
	header       : AllPropTypes.arrayOf(AllPropTypes.oneOfType([AllPropTypes.string, AllPropTypes.element])),
	children     : AllPropTypes.arrayOf(AllPropTypes.element).isRequired,
	openByDefault: AllPropTypes.bool,
	split        : AllPropTypes.bool,
	forceClose   : AllPropTypes.bool,
	corner       : AllPropTypes.elementOf('CollapsibleListGroupCorner')
}


CollapsibleListGroup.Corner = function CollapsibleListGroupCorner ({ action, text, icon, variant, className }) {
	return <Btn swap onClick={action} title={text} {...{ className, icon, variant }}/>
}

CollapsibleListGroup.Corner.propTypes = {
	action   : AllPropTypes.func.isRequired,
	text     : AllPropTypes.string.isRequired,
	icon     : AllPropTypes.string.isRequired,
	variant  : AllPropTypes.string,
	className: AllPropTypes.string,
}
